import { render, staticRenderFns } from "./Catalogue.vue?vue&type=template&id=e8a1bca2&scoped=true"
import script from "./Catalogue.vue?vue&type=script&lang=ts"
export * from "./Catalogue.vue?vue&type=script&lang=ts"
import style0 from "./Catalogue.vue?vue&type=style&index=0&id=e8a1bca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a1bca2",
  null
  
)

export default component.exports